export { useCompanyHomeAgentUiPaths } from './agent-ui-paths';
export { companyHomeFeatureFlags, companyHomeRoute } from './route-config';

export const loadCompanyHomePage = async () => {
    const { CompanyHomePage } = await import('./CompanyHomePage');

    return { Component: CompanyHomePage };
};
